<template>
  <div class="assigned-user__wrap">
    <v-tooltip top :disabled="!userName || fullName">
      <template v-slot:activator="{ on }">
        <div class="assigned-user" v-on="on">
          <avatar
            v-if="!noIcon"
            size="micro"
            :img="userInfo.photo"
            :class="{ 'mr-1': fullName }"
          />
          <div class="assigned-user__initials">
            {{ fullName ? userName || 'Unknown' : shortUserName }}
          </div>
        </div>
      </template>
      <span>{{ userName }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Avatar from '@/components/basic/avatar/Avatar';

export default {
  name: 'UserInfoCircle',
  components: {
    Avatar,
  },
  props: {
    userId: {},
    noIcon: Boolean,
    fullName: Boolean,
  },
  computed: {
    ...mapGetters('users', ['singleUser']),
    userInfo() {
      return this.singleUser(this.userId) || {};
    },
    userName() {
      if (!this.userInfo) return '';
      return this.userInfo?.name || '';
    },
    shortUserName() {
      return this.userName
        .split(' ')
        .map((i) => {
          return i.slice(0, 1);
        })
        .join('');
    },
  },
};
</script>

<style lang="less">
.assigned-user {
  display: flex;
  align-items: center;
  margin-top: 4px;

  &:not(:last-child) {
    margin-right: 10px;
  }

  &__initials {
    padding-left: 4px;
    font-size: 12px;
    font-weight: 600;
  }
}

.v-chip .assigned-user {
  margin: 0 !important;
}
</style>
